import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import sweetalert from 'sweetalert2'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import th from 'vee-validate/dist/locale/th';

// loop over all rules
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: th.messages[rule] // add its message
  });
}

Vue.prototype.$liff = window.liff
Vue.prototype.$swal = sweetalert
Vue.config.productionTip = false

new Vue({
  router,
  created() {
    return (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.com/en_US/messenger.Extensions.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'Messenger'));
  },
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
